var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarLeftBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40002 9.27999C6.40002 8.04799 7.36002 7.03999 8.53336 7.03999H23.4667C24.6449 7.03999 25.6 8.04287 25.6 9.27999V24.96C25.6 26.1971 24.6449 27.2 23.4667 27.2H8.53336C7.35515 27.2 6.40002 26.1971 6.40002 24.96V9.27999ZM8.53336 11.52V24.96H23.4667V11.52H8.53336ZM10.6667 4.79999H12.8V7.03999H10.6667V4.79999ZM19.2 4.79999H21.3334V7.03999H19.2V4.79999ZM10.6667 14.88H12.8V17.12H10.6667V14.88ZM10.6667 19.36H12.8V21.6H10.6667V19.36ZM14.9334 14.88H17.0667V17.12H14.9334V14.88ZM14.9334 19.36H17.0667V21.6H14.9334V19.36ZM19.2 14.88H21.3334V17.12H19.2V14.88ZM19.2 19.36H21.3334V21.6H19.2V19.36Z",
    fill: "#BDC1CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLeftBar);
export default __webpack_public_path__ + "static/media/calendarLeftBar.356b9576.svg";
export { ForwardRef as ReactComponent };